import React, { Component } from "react";
import TagService from "../service/tagService";
import TagList from "../components/tagList";
import NavigationBar from "../components/navigationBar";

export default class TagOverviewSite extends Component {

    constructor(props) {
        super(props);
        this.tagService = new TagService();
        this.state = {
            tags: [],
            releasetagName: "",
            releaseDescription: ""
        }

        this.handleChange = this.handleChange.bind(this);

        this.createReleaseTag = this.createReleaseTag.bind(this);
    }

    componentDidMount() {
        this.getTagInformation();
    }

    async getTagInformation() {

        let result = await this.tagService.getReleaseTags(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tags: result
            })
        }
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }

    async createReleaseTag(event) {
        event.preventDefault();

        let result = await this.tagService.createReleaseTag(this.props.match.params.projectID, this.state.releasetagName, this.state.releaseDescription);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            if (!this.state.NoRedirect) {
                this.hideOverlay();
            }
            this.getTagInformation();
        }
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    render() {
        const tags = this.state.tags;
        if (!tags) return null;

        return (
            <div className="body">
                <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>New Tag</h1></center>
                        <form action="#" onSubmit={(event) => { this.createReleaseTag(event) }}>
                            <label htmlFor="releasetagName"><b>Tag Name:</b></label><br />
                            <input type="text" name="releasetagName" value={this.state.releasetagName} onChange={this.handleChange} required /><br />
                            <label htmlFor="releaseDescription"><b>Tag Description:</b></label><br />
                            <input type="text" name="releaseDescription" value={this.state.releaseDescription} onChange={this.handleChange} required /><br />
                            <button type="submit">Create Tag</button>
                        </form>
                    </div>
                </div>

                <NavigationBar {...this.props} />
                <main>
                    <button onClick={this.showOverlay}>Create New</button>
                    <TagList projectUUID={this.props.match.params.projectID} tags={tags} />
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/tagOverviewSite.js